export default __webpack_public_path__ + "static/design_raining-0c0d998a3036b506d0d874bac9a764dc.svg";